import { Link } from '@/i18n/routing';

export const Pagination = ({ totalPages, page, tab }) => {
  return (
    <div className="tab-content flex flex-wrap gap-8 max-sm:px-4">
      {Array(totalPages)
        .fill()
        .map((item, i) => (
          <div key={i} className="flex flex-col gap-1 min-w-0">
            {i + 1 === page ? (
              <span className="text-slate-500 text-base font-normal leading-tight truncate">
                {i + 1}
              </span>
            ) : (
              <Link
                href={`/sitemap/${tab}/${i + 1}`}
                className="text-slate-500 text-base font-normal underline leading-tight truncate"
                prefetch={false}
              >
                {i + 1}
              </Link>
            )}
          </div>
        ))}
    </div>
  );
};
